<template>
  <div
    class="form-group"
    :class="[
    inputGroupClass,
    {
      'has-prefix': !!$slots.prefix,
      'has-suffix': !!$slots.suffix
    }]"
  >
    <label
      class="form-label"
      for="number-input"
      :class="{ 'has-error ': error }"
      v-if='label'
    >
      {{ label  }}
    </label>
    <div class="form-group__panel">
      <span class="form-control__prefix" for="number-input">
        <slot name="prefix"></slot>
      </span>
      <input
        id="number-input"
        class="form-control"
        :class="[
          inputClasses,
          {
            'disable-input__increment': enableIncrement ? false : true
          }
        ]"
        :style="inputStyles"
        :type="(custom) ? 'text' : defaultType"
        @keypress="handleNumbersOnly($event)"
        v-bind="$attrs"
        v-on="inputListeners"
      />
      <span class="form-control__suffix">
        <slot name="suffix"></slot>
      </span>
    </div>
    <transition name="slide">
      <span v-show="error" class="form-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import themeSetupMixin from '@/mixins/theme';
import inputMixin from '../input.mixin';

export default {
  inheritAttrs: false,
  mixins: [themeSetupMixin, inputMixin],
  props: {
    /**
     * Default input type
    */
    defaultType: {
      type: String,
      default: 'number',
    },
    /**
     * If `true`, it changes the input field type to
     * text in order to allow number formatting
     * E.G phone numbers
    */
    custom: {
      type: Boolean,
      default: false,
    },
    error: String,
    label: String,
    /**
     * If `true`, allows value to be incremented or decremented
    */
    enableIncrement: {
      type: Boolean,
      default: false,
    },
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleNumbersOnly(event) {
      if (this.custom) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return event.preventDefault();
        }
        return true;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control {
    &.disable-input__increment {
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          margin: 0;
      }
    }
}
</style>
